import cRequest from "@services/c-request"

const cartPath = `${process.env.REACT_APP_BASE_URL}/cart`

export const addToCartService = async (body: any) => {
  return cRequest
    .post(`${cartPath}/add-to-cart`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getCartItemsService = async (uid: any) => {
  if (!uid) return []

  return cRequest
    .get(`${cartPath}/get-cart-items`, { params: { uid } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const deleteCartItemService = async (body: any) => {
  return cRequest
    .post(`${cartPath}/delete-cart-item`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const updateCartItemService = async (body: any) => {
  const { data, cartid } = body
  return cRequest
    .post(`${cartPath}/update-cart-item`, { data, cartid })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

// admin
export const getAllCartItemsService = async ({ forApprovals }: any) => {
  return cRequest
    .get(`${cartPath}/get-all-cart-items`, { params: { forApprovals } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
